import { ISolicitationViewModel, ISpecialtyViewModel } from 'viewModels';
import {
  IAddSpecialtiesInputModel,
  IDeleteSpecialtiesInputModel,
  IOrderedWithPaginationInputModel,
} from 'inputModels';
import qs from 'qs';
import api from '../services/api/axios';

const getAll = (input: IOrderedWithPaginationInputModel) =>
  new Promise<ISpecialtyViewModel[]>((resolve) => {
    api
      .get(`/specialty`, { params: input, paramsSerializer: (params) => qs.stringify(params) })
      .then(({ data }) => resolve(data))
      .catch(() => resolve([] as ISpecialtyViewModel[]));
  });

const getSpecialtiesSelectedByUser = (input: IOrderedWithPaginationInputModel) =>
  new Promise<ISpecialtyViewModel[]>((resolve, reject) => {
    api
      .get(`/specialty/get-specialties-by-user`, {
        params: input,
        paramsSerializer: (params) => qs.stringify(params),
      })
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const getSpecialtyById = (id: string) =>
  new Promise<ISpecialtyViewModel>((resolve, reject) => {
    api
      .get(`/specialty/get-specialty-by/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const AddSpecialties = (input: IAddSpecialtiesInputModel) =>
  new Promise<string>((resolve, reject) => {
    api
      .post(`/specialty/add-specialties`, input)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const SpecialtyHasSolicitation = (id: string) =>
  new Promise<ISolicitationViewModel[]>((resolve, reject) => {
    api
      .get(`/specialty/specialty-has-solicitation/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const DeleteSpecialty = (input: IDeleteSpecialtiesInputModel) =>
  new Promise<boolean>((resolve, reject) => {
    api
      .post(`/specialty/delete-specialty`, input)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
const SpecialtyController = {
  getAll,
  getSpecialtiesSelectedByUser,
  getSpecialtyById,
  AddSpecialties,
  SpecialtyHasSolicitation,
  DeleteSpecialty,
};

export default SpecialtyController;
